<template>
  <div id="data-list-list-view" class="data-list-container">
    <key-project-type-side-view
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      @onKeyProjectTypeUpdated="typeUpdated"
      @onKeyProjectTypeInserted="typeInserted"
    />
    <vx-card ref="listCard" :title="$t('KPU.KeyProjectType.Title')" title-color="black" refresh-content-action @refresh="refreshKeyProjectList"> 
      <vs-table
            ref="table"
            v-model="selected"
            search
            :data="keyProjectTypes"
          >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between" class="mr-5">
            <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="12">
              <vx-tooltip :text="$t('AddNew')" position="bottom" delay=".3s">
                <feather-icon icon="PlusCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="addNewData" />
              </vx-tooltip>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th>{{$t('Action')}}</vs-th>
          <vs-th sort-key="title">{{$t('KPU.KeyProjectType.Name')}}</vs-th>
          <vs-th sort-key="isCapitalExpenseRequest">{{$t('KPU.KeyProjectType.IsCapitalExpenseRequest')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.id, tr.name)"
                />
              </vs-td>
              <vs-td>
                <p class="font-medium truncate">{{ tr.name }}</p>
              </vs-td>
              <vs-td width="250px;">
                <vs-checkbox v-model="tr.isCapitalExpenseRequest" class="mb-2" :disabled="true" ></vs-checkbox>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>

import keyProjectTypeSideView from "./components/keyProjectTypeSideView.vue";
import moduleKpu from "./../store/moduleKpu.js";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    keyProjectTypeSideView
  },
  data() {
    return {
      selected: [],    
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    };
  },
  computed: {
    keyProjectTypes() {
      return this.$store.state.kpu.keyProjectTypes;
    }
  },
  methods: {
    refreshKeyProjectList() {
      this.$store.dispatch("kpu/fetchKeyProjectTypes").then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    openDeleteConfirm(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('KPU.KeyProjectType.ConfirmDelete', { name }),
        accept: this.deleteData,
        parameters: id
      });
    },
    deleteData(id) {
      this.$store.dispatch("kpu/removeKeyProjectType", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("KPU.KeyProjectType.KeyProjectTypeDeleted")
          });
        });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    typeUpdated() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });

      this.toggleDataSidebar(false);

    },

    typeInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
    }
  },
  created() {
    if (!moduleKpu.isRegistered) {
      this.$store.registerModule("kpu", moduleKpu);
      moduleKpu.isRegistered = true;
    }
  },
  mounted() {
    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }

    this.isMounted = true;

  }
};
</script>

<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>